export const configApi = {
	apiUrl: 'https://api.ticketshop.com.co/api/' // Servidor Final
	//apiUrl: 'http://api.ticketsshop.com.co/api/' // Servidor de pruebas
};